import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { refresh } from '../../../utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'upgrades.activationModal';
const ActivationErrorModal = () => /*#__PURE__*/_jsxs(Modal, {
  size: "auto",
  use: "conversational",
  width: 500,
  children: [/*#__PURE__*/_jsx(DialogCloseButton, {
    color: "do-not-use-eerie",
    onClick: refresh
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: /*#__PURE__*/_jsxs(ErrorMessage, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.errorTitle`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.errorMessage`
        })
      })]
    })
  })]
});
export default ActivationErrorModal;